import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { map } from 'rxjs';

@Directive({
  selector: '[appDeleteGuard]'
})
export class DeleteGuardDirective {

  
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthenticationService,
  ) {}

  @Input() set appDeleteGuard(moduleName: string) {
      this.authService.getUserPermissionsOnModules(moduleName)
      .subscribe((response) => {
          const pqiAllModules = response.find(
            (res) => res.delete === true 
          );
  
          if (pqiAllModules) {
                  this.viewContainer.createEmbeddedView(this.templateRef);
                  this.hasView = true;
          } else {
                  this.viewContainer.clear();
                  this.hasView = false;
          }
        }
      );
    

  }

}
